export default "__VITE_ASSET__CQHZkAMQ__"